import { GroupAssign, Equipment,CIDMGroup, MembershipType } from "../../booking-table/CustomCells";
import Actions from "./Actions";
import DATA_LABEL_TABLE from "../../../../utils/constants/dataLabelTable";
import {
  ACTION_CELL_STYLE,
  ACTION_COLUMN_FLEX,
  createField,
  createSelectionField,
} from "../../components/tableMetaHelpers";

const truncateCellStyle = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  fontWeight: 500,
  whiteSpace: "nowrap",
  paddingRight: 15,
};

export const getGroupTableMeta = (selectionConfig = null) => {
  const withSelection = Boolean(selectionConfig);

  return {
    fields: {
      ...(withSelection
        ? createSelectionField({
            selectionConfig,
            testIdPrefix: "assign-group-checkbox",
            getItemId: (item) => item?.id,
          })
        : {}),
      equipmentModel: createField(
        DATA_LABEL_TABLE.ADMIN_ASSIGN_GROUP_TABLE.shortIdentifier,
        "0 1 14%",
        Equipment
      ),
      membership: createField("Membership type", "0 1 13%", MembershipType),
      cidm: createField("CIDM Group", "0 1 18%", CIDMGroup, truncateCellStyle),
      users: createField(
        DATA_LABEL_TABLE.ADMIN_ASSIGN_GROUP_TABLE.users,
        "0 1 18%",
        GroupAssign,
        truncateCellStyle
      ),
      groupName: createField(DATA_LABEL_TABLE.ADMIN_ASSIGN_GROUP_TABLE.booking_group, "0 1 22%"),
      action: createField(null, ACTION_COLUMN_FLEX, Actions, ACTION_CELL_STYLE),
    },
  };
};

export default getGroupTableMeta;
